<template>
  <div id="Admin">

    <p v-if="!ready">{{ $t('message.loading') }}</p>

    <section
      v-else
      style="padding: 10px;font-size: 13px;">

      <b-modal
        id="modal-log-detail"
        title="Log"
        size="xl">
        <div>
          <pre>{{ logDetail }}</pre>
        </div>
      </b-modal>

      <p>Logs ({{ logs.length }})</p>
      <table
        class="table"
        width="100%">
        <thead>
          <tr>
            <th style="font-size: 13px;">No.</th>
            <th style="font-size: 13px;">Type</th>
            <th style="font-size: 13px;">Message</th>
            <th style="font-size: 13px;">Created</th>
            <th style="font-size: 13px;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) in logs">
            <td>{{ (index+1) }}</td>
            <td>{{ log.type }}</td>
            <td>{{ log.message }}</td>
            <td>{{ getFriendlyTime(log.created_at) }} <i class="far fa-clock"/> {{ getDateTime(log.created_at) }}</td>
            <td>
              <button
                v-b-modal.modal-log-detail
                type="button"
                class="btn"
                @click="logDetail = log">debugs</button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

  </div>
</template>

<script>
export default {
  name: 'AdminLogErrorFrontAll',
  data () {
    return {
      ready: false,
      logDetail: null,
    }
  },
  computed: {
    logs () {
      return this.$store.getters['logerrorfront/getState']('logs')
    },
  },
  beforeMount: function () {
    // set section
    this.$store.dispatch('setSection', 'admin')
  },
  created: async function () {
    await this.$store.dispatch('logerrorfront/getAll')
    this.ready = true
  },
}
</script>

<style>
  #modal-log-detail .modal-dialog {
    max-width: 95% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/log/error/front/All.vue